<template>
	<div>
		<ul class="wards__list" v-if="items.length > 0">
			<ward v-for="item in items" :item="item" :key="item.id"></ward>
		</ul>
		<div v-else>
			<h5>Вы пока не пригласили пользователей.</h5>
		</div>
	</div>
</template>

<script>
  import ward from './ward'

  export default {
    name: "curator-users",
    components: { ward },
    data() {
      return {}
    },
    props: {
      items: ''
    },
    methods: {}
  }
</script>

<style>

</style>


// WEBPACK FOOTER //
// themes/oprava/src/js/components/commerce/curator-users.vue